import { render, staticRenderFns } from "./LinkModal.vue?vue&type=template&id=ed98d1a6&scoped=true"
import script from "./LinkModal.vue?vue&type=script&lang=js"
export * from "./LinkModal.vue?vue&type=script&lang=js"
import style0 from "./LinkModal.vue?vue&type=style&index=0&id=ed98d1a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed98d1a6",
  null
  
)

export default component.exports